<div class="form border-b border-1 border-gray-500">
  <input [type]="type" [placeholder]="labelText" [formControl]="control" #input (change)="change($event)" (input)="onkeyup($event)" id="text" [value]="value || ''" name="text" class="input {{class}}" autocomplete="off" required />
  <div  class="search">
      <i class="fa fa-search"></i>
  </div>
</div>
